module.exports = __webpack_public_path__ + "img/closewhite.6e75e4d3.svg";